import React, {Component, ReactNode} from 'react'
import {LeftTopColumnFlexContainer} from '../../../styledComponents/FlexComponents'
import FacilitiesRepository from '../../facilities/FacilitiesRepository'
import EventEmitterExResident from '../../shared/pageBaseComponents/EventEmitterExResident'
import FacilityCardInfo from '../../facilities/FacilityCardInfo'
import {getFacilityCategoryImageUrl} from '../../facilities/FacilityCategoryImageHelper'
import {AVAILABLE_OR_NOT, FACILITY_CATEGORY} from '../../../CodeMaster'
import {NatAsyncCallFunction} from '../../../__NoAutomatedTests/common/util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import moment from 'moment'
import ReservationsRepository from '../ReservationsRepository'
import {RRFTFacilitySearchComponentHelper as Helper} from './RRFTFacilitySearchComponentHelper'
import {ResidentReserveFacilityInputPageLocationState} from '../ResidentReserveFacilityInputPage'
import {PlainLinkStyledButton} from '../../../styledComponents/Button'
import {BlockSpacer, currentMedia, RenderSwitchByBreakPoint} from '../../../styledComponents/ResponsiveConvenience'
import {CardList, CoverImage, EllipsisText, StyledCard, StyledSecondaryButton} from '../components/CommonStyle'
import ScrollableCategorySelector from '../../shared/ScrollableCategorySelector'
// import withWidth, {isWidthDown, WithWidthProps} from '@mui/material/Hidden/withWidth'
import {DateRange} from '@mui/icons-material'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {Box, CardActionArea} from '@mui/material'
import {isWidthDown, WithWidth, WithWidthProps} from '../../shared/forms/hoc/withMediaQuery'
import {NavigateFunction} from 'react-router-dom'

export const KEY_SEARCH_CONDITIONS = 'ResidentReserveFacilityTopPage.SearchConditions'

function setResidentReserveTopPageSearchConditions(searchConditions: SearchConditions): void {
    SessionStorageHelper.setItem(
        KEY_SEARCH_CONDITIONS,
        Helper.serializeSearchConditions(searchConditions),
    )
}

function getResidentReserveTopPageSearchConditions(): SearchConditions {
    const json: Nullable<string> = SessionStorageHelper.getStringItemOrNull(KEY_SEARCH_CONDITIONS)
    return json !== null ? Helper.deserializeSearchConditions(json) : {categories: []}
}

export function clearResidentReserveTopPageSearchConditions(): void {
    SessionStorageHelper.removeItem(KEY_SEARCH_CONDITIONS)
}


export interface SearchConditions {
    categories: FACILITY_CATEGORY[]
}

interface Props {
    condominiumCd: string
    facilitiesRepo: FacilitiesRepository
    reservationsRepo: ReservationsRepository
    maxFacilitiesDisplayCount: number
    eventEmitter: EventEmitterExResident
    navigate: NavigateFunction
    holidays: string[]
    currentDateTime: Nullable<moment.Moment>
}

interface State {
    facilityCardInfos: FacilityCardInfo[]
    filteredFacilityCardInfos: FacilityCardInfo[]
    categories: FACILITY_CATEGORY[]
    searchConditions: SearchConditions
    isDisplayAllFacilities: boolean
}

class RRFTFacilitySearchComponent extends Component<Props & WithWidthProps, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            facilityCardInfos: [],
            filteredFacilityCardInfos: [],
            categories: [],
            searchConditions: {
                categories: [],
            },
            isDisplayAllFacilities: false,
        }

        this.handleAllFacilityCard = this.handleAllFacilityCard.bind(this)
        this.handleClickSearchByDateTime = this.handleClickSearchByDateTime.bind(this)
        this.handleChangeCategory = this.handleChangeCategory.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const searchConditions: SearchConditions = getResidentReserveTopPageSearchConditions()
        const facilityCardInfos: FacilityCardInfo[] = await this.getFacilityCardInfos()
        const categories: FACILITY_CATEGORY[] = Helper.extractFacilityCategories(facilityCardInfos)
        this.setState(
            {
                facilityCardInfos,
                categories,
                isDisplayAllFacilities: searchConditions.categories.length !== 0,
            },
            () => this.filterFacilityCardInfos(searchConditions),
        )
    }

    async getFacilityCardInfos(): Promise<FacilityCardInfo[]> {
        let facilityCardInfos: Nullable<FacilityCardInfo[]>

        await this.props.eventEmitter.showLoading()
        try {
            const {facilitiesRepo, condominiumCd, navigate} = this.props

            facilityCardInfos = await NatAsyncCallFunction(
                facilitiesRepo.getFacilityCardInfos.bind(
                    facilitiesRepo,
                    condominiumCd,
                ), navigate)
            if (facilityCardInfos === null) {
                return []
            }
            return facilityCardInfos
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async filterFacilityCardInfos(searchConditions: SearchConditions): Promise<void> {
        const filteredFacilityCardInfos: FacilityCardInfo[] =
            Helper.filterFacilityCardInfosByCategory(
                this.state.facilityCardInfos,
                searchConditions,
            )
        this.setState(
            {
                filteredFacilityCardInfos,
                searchConditions,
            },
        )
    }

    handleClickFacilityCard(facilityId: number): void {
        const {condominiumCd, navigate} = this.props
        const locationState: ResidentReserveFacilityInputPageLocationState = {
            previousPageUrl: `/resident/condominiums/${condominiumCd}/reserve-facility-top`,
        }
        navigate(
            `/resident/condominiums/${condominiumCd}/facilities/${facilityId}/reserve/input`,
            {state: locationState},
        )
    }

    handleAllFacilityCard(): void {
        this.setState({
                isDisplayAllFacilities: true,
            },
        )
    }

    handleClickSearchByDateTime(): void {
        this.props.navigate(`/resident/condominiums/${this.props.condominiumCd}/facilities/reservation-status`)
    }

    handleChangeCategory(selectedCategoryList: FACILITY_CATEGORY[]): void {
        const {searchConditions} = this.state
        if (searchConditions.categories.length === 0 && selectedCategoryList.length === 0) {
            return
        }
        searchConditions.categories = selectedCategoryList
        this.setState({
                searchConditions,
                isDisplayAllFacilities: true,
            },
        )
        setResidentReserveTopPageSearchConditions(searchConditions)
        this.filterFacilityCardInfos(searchConditions)
    }

    renderSearchResult(): ReactNode {
        const {filteredFacilityCardInfos, isDisplayAllFacilities} = this.state
        const {maxFacilitiesDisplayCount} = this.props

        if (filteredFacilityCardInfos.length === 0) {
            return (<>
                <BlockSpacer height={'20px'}/>
                <Message>該当する施設はありません</Message>
            </>)
        }

        const spMode = isWidthDown(this.props.width, true)
        const facilitiesDisplayCount = spMode ? 3 : 6

        const cardList: ReactNode =
            filteredFacilityCardInfos
                .filter((filteredFacilityCardInfo, index) =>
                    index < (isDisplayAllFacilities ? maxFacilitiesDisplayCount : facilitiesDisplayCount))
                .map(filteredFacilityCardInfo => this.renderFacilityCard(filteredFacilityCardInfo))

        let showAllButton: ReactNode = null
        if (!isDisplayAllFacilities && filteredFacilityCardInfos.length > facilitiesDisplayCount) {
            showAllButton = (<>
                <BlockSpacer height={'20px'}/>
                <RenderSwitchByBreakPoint
                    under={
                        <StyledSecondaryButton onClick={this.handleAllFacilityCard}>
                            すべて見る
                        </StyledSecondaryButton>
                    }
                    over={
                        <RightPlainLinkStyledButton onClick={this.handleAllFacilityCard}>
                            すべて見る
                        </RightPlainLinkStyledButton>
                    }
                />
            </>)
        }

        return <>
            <CardList>
                {cardList}
            </CardList>
            {showAllButton}
        </>
    }

    renderFacilityCard(info: FacilityCardInfo): ReactNode {
        let imageUrl: string
        if (info.image !== null) {
            imageUrl = info.image.url
        } else {
            imageUrl = getFacilityCategoryImageUrl(info.category)
        }

        return (
            <StyledCard key={info.facilityId}>
                <CardActionArea onClick={this.handleClickFacilityCard.bind(this, info.facilityId)}>
                    <FacilityCard>
                        <FacilityImage url={imageUrl}/>
                        <FacilityInfo>
                            <FacilityCardTitle>
                                <FacilityCardTitleInner>
                                    <EllipsisText
                                        lineHeightInPixel={20}
                                        numOfLines={3}
                                    >
                                        {info.facilityName}
                                    </EllipsisText>
                                </FacilityCardTitleInner>
                            </FacilityCardTitle>
                            <FacilityCardTag>
                                {info.stayAvailability === AVAILABLE_OR_NOT.AVAILABLE ? '宿泊' : '時間貸し'}
                            </FacilityCardTag>
                        </FacilityInfo>
                    </FacilityCard>
                </CardActionArea>
            </StyledCard>
        )
    }

    render(): ReactNode {
        const {searchConditions, categories} = this.state
        return <>
            <WhiteArea style={{cursor: 'pointer'}} onClick={this.handleClickSearchByDateTime}>
                <SearchMode>
                    <DateRange fontSize="large"/><Box width={8}/>利用日から探す<ForwardArrow/>
                </SearchMode>
            </WhiteArea>
            <BlockSpacer height={'20px'}/>
            {/*横スクロールカテゴリ選択コンポーネントのクリック領域を広げた分の帳尻合わせで、paddingBottomを狭めてます*/}
            <WhiteArea style={{paddingBottom: '5px'}}>
                <SearchMode>
                    <FormatListBulletedIcon sx={{fontSize: 'large'}}/><Box width={8}/>施設一覧から探す
                </SearchMode>
                <Box height={10}/>
                <MarginSetting>
                    <ScrollableCategorySelector
                        onChangeCategory={this.handleChangeCategory}
                        categoryList={categories}
                        selectedCategoryList={searchConditions.categories}
                        displayAllButton
                    />
                </MarginSetting>
            </WhiteArea>
            <BlockSpacer height={'10px'}/>
            {this.renderSearchResult()}
        </>
    }
}

export default WithWidth(RRFTFacilitySearchComponent)

const SearchMode = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  color: ${Colors.AccentDark};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
`

const ForwardArrow = styled.div`
  content: '';
  width: 0.9rem;
  height: 0.9rem;
  border-top: solid 1px ${Colors.Body};
  border-right: solid 1px ${Colors.Body};
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: auto;
`

const WhiteArea = styled.div`
  ${currentMedia.lessThan('sp')`
     margin: 0 -15px 0 -15px;
   `};
  padding: 15px 21px 15px 18px;
  background-color: ${Colors.Surface};
`

const MarginSetting = styled.div`
  margin: 0 -21px 0 -18px;
`
const FacilityCard = styled.div`
  display: flex;
  justify-content: left;
  align-items: flex-start;
`

const FacilityImage = styled(CoverImage)`
  flex: 0 0 130px;
  height: 130px;
  border-radius: 4px 0 0 4px;
`

const FacilityInfo = styled(LeftTopColumnFlexContainer)`
  flex: 1 1 0%;
`

const FacilityCardTitle = styled.div`
  display: table;
  box-sizing: border-box;
  height: 60px;
  width: 100%;
  padding: 10px 10px 0 10px;
`

const FacilityCardTitleInner = styled.div`
  display: table-cell;
  vertical-align: middle;
  color: ${Colors.Body};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Bold};
`

const FacilityCardTag = styled.div`
  color: ${Colors.Body};
  background-color: ${Colors.Background};
  font-size: ${FontSize.Small};
  font-weight: ${FontWeights.Light};
  line-height: 12px;
  margin: 8px 0 0 10px;
  padding: 3px 10px 3px 10px;
`

const RightPlainLinkStyledButton = styled(PlainLinkStyledButton)`
  margin-left: auto;
`

const Message = styled.div`
  color: ${Colors.Body};
  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};
`
